"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("./index");
var _default = exports.default = function _default(callback) {
  try {
    var checkHigherVesion = (0, _index.checkVesionReplay)();
    if (window.Sentry) {
      callback && callback(window.Sentry, checkHigherVesion);
    } else {
      var sentryUrl = 'https://s1.zhuanstatic.com/common/system/js/sentry.es5.min.js';
      (0, _index.loadJs)(sentryUrl, function () {
        if (window.Sentry) {
          callback && callback(window.Sentry, checkHigherVesion);
        }
      }, false);
    }
  } catch (e) {
    console.log('-----sentry日志打印-异步加载异常: ', e);
  }
};